import { render, staticRenderFns } from "./corporate_credit.vue?vue&type=template&id=2ce32322&scoped=true&"
import script from "./corporate_credit.vue?vue&type=script&lang=js&"
export * from "./corporate_credit.vue?vue&type=script&lang=js&"
import style0 from "./corporate_credit.vue?vue&type=style&index=0&id=2ce32322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce32322",
  null
  
)

export default component.exports